import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function useSubscription(session) {
  const [subscribed, setSubscribed] = useState(null);
  const [subscription, setSubscription] = useState(null);

  const check = useCallback(async () => {
    if (!session) return;
    const { data } = await supabase
      .from('subscriptions')
      .select('*')
      .eq('user_id', session.user.id)
      .in('status', ['active', 'trialing'])
      .single();
    setSubscription(data || null);
    setSubscribed(!!data);
  }, [session]);

  useEffect(() => {
    check();
  }, [check]);

  return { subscribed, subscription, refresh: check };
}

